import { JSXElementConstructor } from 'react';
import { AVAILABLE_WORLDS } from '../../languages/constants';
import SaleBar from './components/sale-bar/sale-bar';
import TwentyFiveEuroIncentive from './messages/twenty-five-euro-incentive/twenty-five-euro-incentive';

type Config = {
    [K: string]: {
        MessageComponent: JSXElementConstructor<{}>;
        bannerId: string;
        isShowBanner: boolean;
    };
};

export const SALE_CONFIG: Config = {
    [AVAILABLE_WORLDS.DE]: {
        MessageComponent: SaleBar,
        bannerId: 'flash-sale-bar-2025',
        isShowBanner: true
    },
    [AVAILABLE_WORLDS.ES]: {
        MessageComponent: SaleBar,
        bannerId: 'flash-sale-bar-2025',
        isShowBanner: true
    },
    // [AVAILABLE_WORLDS.FR]: {
    //     MessageComponent: NewYearSaleBar,
    //     bannerId: 'new-year-sale-bar-2024',
    //     isShowBanner: true
    // },
    [AVAILABLE_WORLDS.IT]: {
        MessageComponent: SaleBar,
        bannerId: 'flash-sale-bar-2025',
        isShowBanner: true
    },
    [AVAILABLE_WORLDS.GR]: {
        MessageComponent: SaleBar,
        bannerId: 'flash-sale-bar-2025',
        isShowBanner: true
    }
};

export const TWENTY_FIVE_EUR_INCENTIVE = '25_eur_incentive_banner';

export const DEFAULT_CONFIG = {
    // [AVAILABLE_WORLDS.DE]: {
    //     MessageComponent: TwentyFiveEuroIncentive,
    //     bannerId: `${TWENTY_FIVE_EUR_INCENTIVE}_de`
    // },
    [AVAILABLE_WORLDS.ES]: {
        MessageComponent: TwentyFiveEuroIncentive,
        bannerId: `${TWENTY_FIVE_EUR_INCENTIVE}_es`
    },
    // [AVAILABLE_WORLDS.FR]: {
    //     MessageComponent: TwentyFiveEuroIncentive,
    //     bannerId: `{}TWENTY_FIVE_EUR_INCENTIVE_fr'`// },
    [AVAILABLE_WORLDS.IT]: {
        MessageComponent: TwentyFiveEuroIncentive,
        bannerId: `${TWENTY_FIVE_EUR_INCENTIVE}_it`
    },
    [AVAILABLE_WORLDS.GR]: {
        MessageComponent: TwentyFiveEuroIncentive,
        bannerId: `${TWENTY_FIVE_EUR_INCENTIVE}_gr`
    }
};

export const CLOSED_BANNER_STORAGE_VALUE = 'closed';

export enum MARKETING_BAR_ACTIONS {
    SHOWN = 'shown',
    CLICKED = 'clicked',
    CLOSED = 'closed'
}
